import React from "react";
import { useLanguage } from "../../../../contexts";
import "../RiskMatrixGuide/RiskMatrixGuide.scss";

export function GriGuide() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <div className="risk-matrix-guide">
      <h2>{t("risk_matrix_gri_guide_title")}</h2>
      <p>{t("risk_matrix_gri_guide_intro")}</p>
      <ol>
        <li>{t("risk_matrix_gri_guide_step1")}</li>
        <li>{t("risk_matrix_gri_guide_step2")}</li>
        <li>{t("risk_matrix_gri_guide_step3")}</li>
        <li>{t("risk_matrix_gri_guide_step4")}</li>
      </ol>

      <div className="risk-matrix-guide__note">{t("risk_matrix_gri_guide_auto_note")}</div>

      <h3>{t("risk_matrix_guide_criteria_title")}</h3>
      <table className="risk-matrix-guide__table">
        <thead>
          <tr>
            <th>{t("risk_matrix_guide_criteria_component")}</th>
            <th>{t("risk_matrix_guide_criteria_scale")}</th>
            <th>{t("risk_matrix_guide_criteria_use")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t("risk_matrix_gri_scale")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_gri_guide_scale_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_gri_scope")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_gri_guide_scope_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_gri_irremediability")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_gri_guide_irremediability_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_probability")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_gri_guide_probability_use")}</td>
          </tr>
        </tbody>
      </table>

      <div className="risk-matrix-guide__ref">{t("risk_matrix_gri_guide_traceability")}</div>
    </div>
  );
}
